export default theme => ({
  shippingPanel: {
    display: "flex", 
    flexWrap: "wrap"
  },
  shippingFormContainer: {
    width: "43%"
  }
});
